import { isNil, maxBy } from 'lodash';
import { createSelector } from 'reselect';

import config from 'config';

import { CREATED, CONNECTING } from 'modules/common/constants/conversationStatuses';
import * as APPOINTMENT_STATUSES from 'modules/common/constants/appointmentStatuses';
import * as INTERNAL_APPOINTMENT_STATUSES from 'modules/common/constants/internalAppointmentStatuses';

import { WALK_IN } from 'modules/queues/constants/queueTypes';

import { getCurrentAppointment } from './currentAppointment';

export const getInternalAppointmentStatus = createSelector(
  getCurrentAppointment,
  appointment => {
    const filteredConversations = appointment.conversations.filter(conversation => ![CONNECTING, CREATED].includes(conversation.status));
    const lastConversation = maxBy(filteredConversations, 'conversationId');

    const { queueType } = appointment.service.config;
    const isOverdue = queueType !== WALK_IN && isNil(lastConversation) && appointment.schedules[0].startTime - Date.now() <= config.overdue_time;

    switch (true) {
      case APPOINTMENT_STATUSES.CLOSED_APPOINTMENT_STATUSES.includes(appointment.status):
        return { status: INTERNAL_APPOINTMENT_STATUSES.CLOSED };
      case !!lastConversation:
        return { status: INTERNAL_APPOINTMENT_STATUSES.HAS_LAST_CONVERSATION, lastConversation };
      case isOverdue:
        return { status: INTERNAL_APPOINTMENT_STATUSES.OVERDUE };
      default:
        return { status: INTERNAL_APPOINTMENT_STATUSES.UPCOMING };
    }
  },
);
